/** ປິດ gap/py default ຂອງ Card — ກຳນົດໃນ header/content ເອງ */
export const TRANSFER_CARD = "gap-0 py-0 rounded-xl border bg-card shadow-sm";

export const TRANSFER_CARD_HEADER = "gap-1 pt-4 pb-3";

/** ຫົວຕາຕະລາງໃນ card */
export const TRANSFER_CARD_HEADER_TABLE =
  "border-border gap-1 border-b pt-4 pb-3";

export const TRANSFER_CARD_CONTENT = "pb-4 pt-0";

export const TRANSFER_CARD_CONTENT_TABLE = "px-0 pb-0 pt-0";

/** Card ມີແຕ່ content (ບໍ່ມີ header) */
export const TRANSFER_CARD_BODY_ONLY = "py-4";

/** KPI / stat cards */
export const TRANSFER_STAT_CARD = "gap-0 py-0 rounded-xl border bg-card shadow-sm";

export const TRANSFER_STAT_CARD_BODY = "flex items-center gap-4 py-4";

/** ຊ່ອງລະຫວ່າງ card / section */
export const TRANSFER_SECTION_STACK = "flex flex-col gap-4";

export const TRANSFER_STAT_GRID = "grid gap-4 sm:grid-cols-2 lg:grid-cols-4";

export const TRANSFER_STAT_GRID_3 = "grid gap-4 sm:grid-cols-3";

/** ແຖບຕົວກອງ */
export const TRANSFER_FILTER_CARD = "gap-0 py-0 rounded-xl border bg-card shadow-sm";

export const TRANSFER_FILTER_BODY = "flex flex-wrap items-center gap-2 px-4 py-3";

/** ຕາຕະລາງຄຳຂໍ (list page) */
export const TRANSFER_LIST_SHELL =
  "flex flex-col gap-0 py-0 rounded-xl border bg-card shadow-sm";

export const TRANSFER_LIST_FILTER = "border-border border-b px-4 py-3";
